import { useEffect, useState } from "react";
import { HappyTailListResponseSimplified } from "./types.ts";
import { fetchHappyTailList } from "./service.ts";
import Skeleton from "react-loading-skeleton";
import { AdoptedPetsCarousel } from "./AdoptedPetsCarousel.tsx";

export function AdoptedPetsCarouselWrapper() {
  const [response, setResponse] = useState<
    HappyTailListResponseSimplified | undefined
  >();
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    (async () => {
      setIsFetching(true);
      const res = await fetchHappyTailList({
        pSpeciesID: 0,
        pOrderBy: "AnimalID",
        pCount: 100,
      });
      setResponse(res);
      setIsFetching(false);
    })();
  }, []);

  if (isFetching) {
    return <Skeleton count={4} />;
  }

  return (
    <div>{response && <AdoptedPetsCarousel items={response.items} />}</div>
  );
}
